/**
 * Labstep
 *
 * @module components/Entity/Table/SortOptions/Order
 * @desc Sort options order action
 */

import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import styles from './styles.module.scss';
import type { EntityTableSortOptionsOrderProps } from './types';

export const EntityTableSortOptionsOrder: React.FC<
  EntityTableSortOptionsOrderProps
> = ({ activeSortKey, setParams }) => {
  const isOrderDesc = activeSortKey[0] === '-';
  return (
    <span
      className={styles.arrowContainer}
      onClick={(): void => {
        setParams({
          sort: isOrderDesc
            ? activeSortKey.slice(1)
            : `-${activeSortKey}`,
        });
      }}
    >
      <Icon
        name="long arrow alternate up"
        disabled={isOrderDesc}
        link
      />
      <Icon
        name="long arrow alternate down"
        disabled={!isOrderDesc}
        link
        className={styles.arrowDown}
      />
    </span>
  );
};
